import { ReactNode } from "react";
import { Icon } from "../icons/icon";

export const InformationCard = ({
  info,
  className = "",
  innerClassName = "",
  variant = "green",
  size = "regular",
  hasIcon = true,
  actionElement,
  icon = "info-icon",
}: {
  info: ReactNode;
  className?: string;
  innerClassName?: string;
  variant?: "green" | "purple" | "danger";
  size?: "regular" | "mini";
  hasIcon?: boolean;
  actionElement?: ReactNode;
  icon?: string;
}) => {
  const getColor = () => {
    switch (variant) {
      case "green":
        return "bg-light-green-bg-100 border-pry-dark-green-300/10";
      case "purple":
        return "bg-info-purple-bg border-light-purple";
      case "danger":
        return "bg-light-red-bg-50 border-red-200 text-red-200";
      default:
        return "bg-light-green-bg-100 border-pry-dark-green-300/10";
    }
  };
  return (
    <div
      className={`
        w-full
        ${size === "regular" && "px-4 py-6"}
        ${size === "mini" && "px-2 py-2"}
        ${getColor()}
        border
        rounded-[8px]
        flex flex-row flex-wrap
        items-start
        gap-2
        ${className}
        `}
    >
      <div
        className={`
          flex-1
          flex items-start gap-2
          ${innerClassName}
        `}
      >
        {hasIcon && (
          <Icon
            svg={icon}
            className={`
            ${size === "regular" && "w-[20px] h-[20px]"}
            ${size === "mini" && "w-[14px] h-[14px]"}
            `}
          />
        )}

        <div
          className={`
            ${size === "regular" && "text-sm"}
            ${size === "mini" && "text-xs"}
            `}
        >
          {info}
        </div>
      </div>

      {actionElement && <>{actionElement}</>}
    </div>
  );
};

export const InformationCardNoIcon = ({
  info,
  className,
}: {
  info: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={`
            w-full
            text-sm
            py-1 px-[9px]
            bg-light-green-bg-300
            border border-transparent rounded-[4px]
            ${className}
            `}
    >
      {info}
    </div>
  );
};
